import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SendPurchasesContainerComponent } from './send-purchases-container/send-purchases-container.component';
import { SendPurchasesPresenterComponent } from './send-purchases-presenter/send-purchases-presenter.component';
import { SendPurchasesFilterComponent } from './send-purchases-filter/send-purchases-filter.component';
import { SharedModule } from '../../shared/shared.module';
import { UIRouterModule } from '@uirouter/angular';
import { QuickbooksSendPurchasesRoute } from './send-purchases.route';

@NgModule({
    declarations: [
        SendPurchasesContainerComponent,
        SendPurchasesPresenterComponent,
        SendPurchasesFilterComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        UIRouterModule.forChild({
            states: [QuickbooksSendPurchasesRoute]
        })
    ]
})
export class SendPurchasesModule {}
